<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <v-card :flat="phoneOnly" class="px-4 px-md-3 px-md-0" :class="{'transparent': phoneOnly, 'soft-shadow': pcOnly}" style="min-height: 50vh; max-width: 900px">
                <!-- <div class="d-flex flex-column flex-lg-row justify-space-between px-4 pt-3">
                    <div>
                        <v-text-field :disabled="!myCourses || !myCourses.length" max-width="300" type="search" filled :append-icon="searchQuery ? 'mdi-close' : 'mdi-magnify'" @click:append="searchQuery = ''" hide-details placeholder="Search in Courses" dense v-model="searchQuery" :style="pcOnly ? 'width: 280px;' : ''"/>
                    </div>
                </div> -->

                <div v-if="loading">
                    <v-progress-circular indeterminate transition="fade-transition" color="primary" size="36" width="3"></v-progress-circular>
                </div>
                <div v-else-if="(myCourses && myCourses.length) || (myPrograms && myPrograms.length)">
                    <div v-if="myCourses && myCourses.length" class="mb-6">
                        <div class="details-text ps-2 py-2 muted--text mb-1">My Courses</div>
                        <v-list class="pa-0">
                            <v-list-item v-for="(course) in visibleCourses" :key="course.id" class="bordered rounded mb-3" :to="isStudent ? {name: 'course', params: {id: course.id}} : undefined" v-ripple="false">
                                <v-list-item-avatar v-ripple="{class: 'white--text'}" height="75" tile width="120" class="rounded">
                                    <v-img :src="course.course.image_url" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <router-link :to="isStudent ? {name: 'course', params: {id: course.course.id}} : undefined" class="text-decoration-none">
                                        <v-list-item-title class="strong-text--text">
                                            <span>{{ course.course.name }}</span>
        
                                            <span v-if="!walletDisabled" class="small-text primary--text ms-2 font-weight-semibold">${{ course.hourly_price }} / hour</span>
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="mb-1 text--text font-weight-semibold d-flex align-center">
                                            <div v-if="course.teacher">
                                                <v-chip small label color="grey lighten-2" class="px-2">{{ course.teacher.name }}</v-chip>
                                            </div>
                                            <div class="ms-2">
                                                <v-chip small label color="grey lighten-2" class="px-2">{{course.course.category_name}}</v-chip>
                                            </div>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="course.material_url" class="mt-3">
                                            <v-btn color="primary" depressed small style="text-transform: capitalize;" :target="capRunning ? '_system' : '_blank'" :href="course.material_url" @click.stop @touchstart.stop @mouseenter.stop>
                                                <v-icon size="17" left class="me-1">mdi-file-document-multiple</v-icon>
                                                <span>Course Material</span>
                                            </v-btn>
                                        </v-list-item-subtitle>
                                    </router-link>
                                </v-list-item-content>
                                
                            </v-list-item>
                        </v-list>
                    </div>
                    <div v-if="myPrograms && myPrograms.length" class="mb-6">
                        <div class="details-text ps-2 py-2 muted--text mb-1">My Group Classes</div>
                        <v-list class="pa-0">
                            <v-list-item v-for="(programSubscription) in myPrograms" :key="programSubscription.id" class="bordered rounded mb-3" :to="isStudent ? {name: 'program', params: {id: programSubscription.program.id}} : undefined" v-ripple="false">
                                <v-list-item-avatar v-ripple="{class: 'white--text'}" height="75" tile width="120" class="rounded">
                                    <v-img :src="programSubscription.program.image_url" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <router-link :to="isStudent ? {name: 'program', params: {id: programSubscription.program.id}} : undefined" class="text-decoration-none">
                                        <v-list-item-title class="strong-text--text mb-1">
                                            <span>{{ programSubscription.program.name }}</span>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="!programSubscription.material_url" class="mb-2 text--text font-weight-semibold d-flex align-center">
                                            <div>
                                                <v-chip small label color="grey lighten-2" class="px-2">{{ programSubscription.program.category_name }}</v-chip>
                                            </div>
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="programSubscription.material_url" class="mt-2">
                                            <v-btn color="primary" small depressed style="text-transform: capitalize;" :target="capRunning ? '_system' : '_blank'" :href="programSubscription.material_url" @click.stop @touchstart.stop @mouseenter.stop>
                                                <v-icon size="17" left class="me-1">mdi-file-document-multiple</v-icon>
                                                <span>Material</span>
                                            </v-btn>
                                        </v-list-item-subtitle>
                                    </router-link>
                                </v-list-item-content>
                                
                            </v-list-item>
                        </v-list>
                    </div>
                </div>
                <!-- <v-row v-if="myCourses && myCourses.length" :key="0">
                    <v-col v-for="course in visibleCourses" :key="course.id" :cols="12" :md="6" :lg="4" :xl="3">
                        <course-card enrolled :course="course" style="height: 100%"/>
                    </v-col>
                </v-row> -->
                <div v-else :key="1" class="my-2">
                    <v-alert type="info" color="muted" text class="d-flex">
                        <div class="strong-text--text">No Enrolled Courses!</div>
                        <v-btn :to="{name: 'courses'}" class="mt-2 mx-2" depressed color="primary" outlined>
                            <span>Check our courses</span>
                            <v-icon right size="20">mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-alert>
                </div>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CourseCard from '@/components/custom/course-card'

export default {
  name: "MyCourses",
  components: {
    CourseCard
  },
  data(){
      return {
          searchQuery: '',
          loading: false,
          myCourses: null,

          myPrograms: null,
      }
  },
  computed: {
    walletDisabled(){
        return !this.appData.enable_app_w;
    },
    visibleCourses(){
        const query = this.searchQuery.toLowerCase();
        let courses = this.myCourses;
        if (query){
            return courses.filter(course=>course.name.toLowerCase().search(query) !== -1 || course.category_name.toLowerCase().search(query) !== -1)
        }
        return courses;
    },
    ...GlobalComputed
  },
  methods: {
        ...GlobalMethods,
        
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('fastGetAction', {url: '/my-courses'}).then((response)=>{
                    this.myCourses = response.data.enrollments;
                    this.myPrograms = response.data.program_subscriptions;
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
  },
  mounted(){
    this.loadData();
  }
};
</script>
